import {
  Button,
  Checkbox,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Select,
} from "antd";
import dayjs from "dayjs";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SurveyLogo from "../assets/images/survey_logo.svg";
import SurveyFormImg from "../assets/images/SurveyForm.png";
import MyFileUpload from "../Components/Interactions/MyFileUpload";
import { addPotentialUser } from "../services/awsServices";
import country from "../utils/country.json";
import { SurveyMenu } from "../utils/icons";
import toastMessage from "../utils/toastMessage";
import { uploadDocFunWithoutToken } from "../utils/utils";

function SurveyForm() {
  const [uploadDoc, setUploadDoc] = useState();
  const [loading, setLoading] = useState();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { VITE_APP_DATE_FORMAT } = import.meta.env;
  const onFinish = async (values) => {
    try {
      const data = {
        SK: "Potential#Talent",
        Name: values.name,
        Email: values.email,
        Nationality: values.nationality,
        Dob: dayjs(values.birthdate).format(VITE_APP_DATE_FORMAT),
        Gender: values.gender,
        Attachment: uploadDoc,
        ReferBy: values.ReferBy,
        IntrestedTrack: values.track,
      };

      const res = await addPotentialUser(data);

      if (res) {
        toastMessage(res?.data.message, "success");
        form.resetFields();
      }
    } catch (error) {
      toastMessage(error?.response?.data?.message, "error");
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const props = {
    // name: "attachments",
    headers: {
      authorization: "authorization-text",
    },
    accept: "*",
    multiple: false,
    // showUploadList: false,
    beforeUpload: () => false,
    onChange: async () => {
      setLoading(true);
      const res = await uploadDocFunWithoutToken(form.getFieldValue("cv"));
      if (res) {
        setUploadDoc(res);
      }
      setLoading(false);
    },
    // fileList: attachments,
  };

  const items = [
    {
      key: "2",
      label: (
        <a rel="noopener noreferrer" onClick={() => navigate("/survey")}>
          About M3
        </a>
      ),
    },
    {
      key: "3",
      label: (
        <a rel="noopener noreferrer" onClick={() => navigate("/Survey-Form")}>
          Fill Form
        </a>
      ),
    },
  ];

  return (
    <div className="lg:flex min-h-screen overflow-auto lg:relative">
      <div className="sm:w-full lg:w-[50%] bg-[#0C0B1C] place-content-center lg:absolute lg:top-0 lg:left-0 lg:h-full flex items-center">
        <div className="flex items-center justify-between absolute top-5 p-3 bg-[#FFFFFF33] rounded-3xl w-[95%]">
          <img src={SurveyLogo} alt="SurveyLogo" />
          <Dropdown
            menu={{
              items,
            }}
            placement="bottomRight"
          >
            <button>
              <SurveyMenu />
            </button>
            {/* <a onClick={(e) => e.preventDefault()}>
            </a> */}
          </Dropdown>
        </div>
        <img src={SurveyFormImg} alt="SurveyForm" />
      </div>
      <div className="px-5 overflow-auto p-5 lg:absolute lg:top-0 lg:left-1/2 lg:h-full">
        <div className="text-center">
          <h1 className="bg-signupTextBg inline-block text-transparent bg-clip-text font-bold text-3xl">
            Let&apos;s Get to know you more !
          </h1>
        </div>
        <Form
          form={form}
          layout="vertical"
          className="sm:w-full lg:w-[50%] m-auto"
          // m-auto h-full mb-[150px]"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            rules={[{ required: true, message: "Please Input Your Name" }]}
            label="Hello, What’s your Name"
            name="name"
          >
            <Input className="rounded-3xl" placeholder="Full Name" />
          </Form.Item>
          <Form.Item
            rules={[{ required: true, message: "Please Input Your Email" }]}
            label="Write your email so we can contact you"
            name="email"
          >
            <Input
              className="rounded-3xl"
              type="email"
              placeholder="Email Address"
            />
          </Form.Item>
          <Form.Item
            rules={[
              { required: true, message: "Please Input Your Nationality" },
            ]}
            label="Where are you from? / Nationality"
            name="nationality"
          >
            <Select placeholder="Nationality" showSearch>
              {country.map((item) => (
                <Select.Option key={item.label} value={item.label}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            rules={[{ required: true, message: "Please Input Your Gender" }]}
            label="Select Your Gender"
            name="gender"
          >
            <Select placeholder="Select Your Gender">
              <Select.Option key="male">Male</Select.Option>
              <Select.Option key="female">female</Select.Option>
              <Select.Option key="prefer_not_say">Prefer Not Say</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            rules={[
              { required: true, message: "Please Input Your Birth Date" },
            ]}
            label="What’s your date of birth"
            name="birthdate"
          >
            <DatePicker
              className="w-full rounded-2xl"
              placeholder="DD/MM/YYY"
            />
          </Form.Item>
          <Form.Item label="Upload your CV (It’s Optional)" name="cv">
            <MyFileUpload type="not" {...props}>
              <Input className="rounded-3xl" placeholder="Attachment" />
            </MyFileUpload>
          </Form.Item>
          <Form.Item
            rules={[{ required: true, message: "Please Select Your Track" }]}
            label="Which track are you most interested in?"
            name="track"
          >
            <Checkbox.Group>
              <Checkbox className="w-full" value="Leadership">
                Leadership
              </Checkbox>
              <Checkbox className="w-full" value="Research and Development">
                Research and Development
              </Checkbox>
              <Checkbox className="w-full" value="Entrepreneurship">
                Entrepreneurship
              </Checkbox>
              <Checkbox className="w-full" value="Professional in STEM field">
                Professional in STEM field
              </Checkbox>
              <Checkbox className="w-full" value="Data Science Specialist">
                Data Science Specialist
              </Checkbox>
            </Checkbox.Group>
          </Form.Item>
          <Form.Item label="How did you hear about us?" name="ReferBy">
            <Input
              className="rounded-3xl"
              placeholder="How did you hear about us?"
            />
          </Form.Item>
          <Form.Item>
            <Button
              loading={loading}
              type="default"
              htmlType="submit"
              className="m-auto flex items-center justify-center gap-x-4 py-2 px-6 bg-gradient-to-l from-darkerOrange via-darkOrange to-lightOrange hover:bg-gradient-to-bl text-white drop-shadow-md rounded-full"
            >
              Send Form
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

export default SurveyForm;
